import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';

const rows = [
    { id: 'slug', disablePadding: true, label: 'Slug', sortable: true },
    { id: 'title', disablePadding: false, label: 'Title', sortable: true },
    { id: 'category', disablePadding: false, label: 'Category', sortable: true },
    { id: 'publishedAt', disablePadding: false, label: 'Published', sortable: true },
    { id: 'updated_at', disablePadding: false, label: 'Updated At', sortable: true },
];

interface MatTableHeadProps {
    onRequestSort: (event: unknown, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({ order, orderBy, onRequestSort }: MatTableHeadProps) => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(event) => onRequestSort(event, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
